module.exports = __webpack_public_path__ + "img/output-4.69c460dd.png";